<div *ngIf="(isMobile===false)" class="relative">
     <div *ngIf="selectedAsset && selectedAsset.type === 'IMAGE'" (click)="openAsset(selectedAsset)" class="cursor-zoom-in">
          <img
               loading="lazy"
               [src]="selectedAsset | assetPreview:'large':'webp'"
               [alt]="selectedAsset.customFields?.altText || 'variant featured image'"
               (load)="onLoad()"
               class="w-full h-full object-center object-cover aspect-[1/1] pointer-events-none"
          />
     </div>
     <div *ngIf="isVimeoVideo(selectedAsset)"
          class="relative cursor-pointer"
          (click)="openAsset(selectedAsset)">
          <img  [src]="selectedAsset | assetPreview:'large':'webp'"
               [alt]="selectedAsset.customFields?.altText || 'variant featured video'"
               class="w-full h-full object-cover aspect-[1/1] pointer-events-none"
          />
          <div class="absolute inset-0 bg-black/10 flex items-center justify-center">
               <fa-icon [icon]="['far', 'circle-play']"
                 class="text-8xl text-white drop-shadow-lg pointer-events-none">
               </fa-icon>
          </div>
     </div>
     <div *ngIf="isBrowser && displayThumbnails" class="w-full relative">
          <div *ngIf="selectedAssetIndex > 0">
               <img *ngIf="arrowType === 'large-chevron'"
                    src="assets/left_chevron.png"
                    alt="left chevron icon"
                    class="cursor-pointer left-button mr-1"
                    (click)="onClickPrev()"
               >
               <button *ngIf="['small-arrow'].includes(arrowType)"
                    class="absolute rounded-full left-0 my-1uto top-1/2 -translate-y-1/2 z-10 bg-primary-500 cursor-pointer
                          w-[20px] h-[20px] text-white hover:text-slate-700
                          flex items-center justify-center p-0"
                    style="left: -25px;"
                    (click)="onClickPrev()">
                    <fa-icon class="text-[10px]" icon="arrow-left"></fa-icon>
               </button>
               <button *ngIf="['chevron', 'arrow', 'caret'].includes(arrowType)"
                    class="absolute  rounded-full left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 cursor-pointer
                           w-[40px] h-[40px] text-3xl text-slate-500 hover:text-slate-300"
                    style="left: -20px;"
                    (click)="onClickPrev()">
                    <span>
                         <fa-icon *ngIf="arrowType === 'chevron'" icon="chevron-left"></fa-icon>
                         <fa-icon *ngIf="arrowType === 'arrow'" icon="arrow-left"></fa-icon>
                         <fa-icon *ngIf="arrowType === 'caret'" icon="caret-left"></fa-icon>
                    </span>
               </button>
          </div>
          <div class="thumbnails-container">
               <swiper-container appSwiper #desktopSwiper auto-height=true lazy="true"
                    [slidesPerView]="slidesPerView" space-between=20 rewind=true pagination="false"
                    [centeredSlides]="assets?.length > 3 && selectedAssetIndex > 0"
                    class="flex-grow object-cover">
                    <swiper-slide *ngFor="let image of assets; let i = index"
                         class="swiper-slide"
                         [ngClass]="{'selected-slide': selectedAssetIndex === i}"
                         (click)="selectImage(image.id)"
                    >
                         <div class="relative flex justify-center items-center w-full h-full image-container">
                              <img  [src]="image | assetPreview:'medium':'webp'"
                                   loading="lazy"
                                   [alt]="image.customFields?.altText || 'variant featured image'"
                                   class="swiper-lazy w-full h-full object-cover aspect-[1/1] pointer-events-none"
                              />
                              <div *ngIf="isVimeoVideo(image)"
                                   class="absolute inset-0 bg-black/20 flex items-center justify-center">
                                   <fa-icon [icon]="['far', 'circle-play']"
                                        class="text-6xl text-white drop-shadow-lg pointer-events-none">
                                   </fa-icon>
                              </div>
                              <div class="swiper-lazy-preloader"></div>
                         </div>
                    </swiper-slide>
               </swiper-container>
          </div>
          <div *ngIf="selectedAssetIndex < assets.length - 1">
               <img *ngIf="arrowType === 'large-chevron'"
                    src="assets/right_chevron.png"
                    alt="right chevron icon"
                    class="cursor-pointer right-button ml-1"
                    (click)="onClickNext()"
               >
               <button *ngIf="['small-arrow'].includes(arrowType)"
                    class="absolute rounded-full right-0 my-1uto top-1/2 -translate-y-1/2 z-10 bg-primary-500 cursor-pointer
                          w-[20px] h-[20px] text-white hover:text-slate-700
                          flex items-center justify-center p-0"
                    style="right: -25px;"
                    (click)="onClickNext()">
                    <fa-icon class="text-[10px]" icon="arrow-right"></fa-icon>
               </button>
               <button *ngIf="['chevron', 'arrow', 'caret'].includes(arrowType)"
                    class="absolute rounded-full right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 cursor-pointer
                          w-[40px] h-[40px] text-3xl text-slate-500 hover:text-slate-300"
                    style="right: -20px;"
                    (click)="onClickNext()">
                    <span>
                         <fa-icon *ngIf="arrowType === 'chevron'" icon="chevron-right"></fa-icon>
                         <fa-icon *ngIf="arrowType === 'arrow'" icon="arrow-right"></fa-icon>
                         <fa-icon *ngIf="arrowType === 'caret'" icon="caret-right"></fa-icon>
                    </span>
               </button>
          </div>
     </div>
</div>
<div *ngIf="isMobile">
     <!-- If we are in the browser, show the Swiper. Otherwise, show the fallback -->
     <ng-container *ngIf="isBrowser; else fallbackImage">
          <swiper-container appSwiper #mobileSwiper
               pagination-type="bullets"
               auto-height="true"
               [dynamicBullets]="true"
               [observer]="true"
               pagination-clickable="true"
               centered-slides="true"
               rewind="true"
               effect="fade"
               grab-cursor="true"
               lazy="true"
               class="flex-grow object-cover custom-pagination">
               <swiper-slide *ngFor="let asset of assets" (click)="openAsset(asset)">
                    <div class="swiper-zoom-container relative">
                         <img  [src]="asset | assetPreview:'medium':'webp'"
                            [alt]="asset.customFields?.altText || 'variant asset preview'"
                            loading="lazy"
                            (load)="onLoad()"
                            class="swiper-lazy w-full h-full object-center object-cover aspect-[1/1] pointer-events-none"
                         />
                         <div *ngIf="isVimeoVideo(asset)"
                              class="absolute inset-0 flex bg-black/20 items-center justify-center">
                              <fa-icon [icon]="['far', 'circle-play']"
                                   class="text-8xl text-white drop-shadow-lg pointer-events-none">
                              </fa-icon>
                         </div>
                         <div class="swiper-pagination"></div>
                         <div class="swiper-lazy-preloader"></div>
                    </div>
               </swiper-slide>
          </swiper-container>
     </ng-container>

     <!-- Fallback template for SSR -->
     <ng-template #fallbackImage>
          <div class="h-full flex justify-center items-center" style="background: #eee;">
               <ng-container *ngIf="assets?.[0] as firstAsset">
                    <ng-container *ngIf="firstAsset.type === 'IMAGE'">
                         <img [src]="firstAsset | assetPreview:'medium':'webp'"
                              [alt]="firstAsset.customFields?.altText ? firstAsset.customFields?.altText : 'variant featured image'"
                              class="object-cover w-full h-full"
                              style="pointer-events: none;" />
                    </ng-container>
               </ng-container>
          </div>
     </ng-template>
</div>